import { Chip, Avatar, Typography } from "@material-tailwind/react";

export default function Timings() {
  return (
    <div className="chipc">
      <p
        style={{
          color: "black",
          fontSize: "17px",
          fontWeight: "650",
          marginLeft: "30px",
          textAlign: "center",
        }}
      >
        Timings : Morning 10:00AM - Evening 6:00PM (IST) || Monday to Sunday ||
        Book your Appointment Now +91 78144 72221 (WhatsApp only) <br /> ONLINE
        : 24x7 (Services Available Globally as per Appointment Only)
      </p>
    </div>
  );
}
